import Button from '@anm/components/buttons/Button';
import { FC } from 'react';

import vtConfig from '../../../config';
import Navigation from '../../Navigation';
import AuthUserMenuBlock from '../../auth/AuthUserMenuBlock';
import StudioUserMenuBlock from '../StudioUserMenuBlock';

const createNewUrl = `${vtConfig().urls.studioEditor}#new=1`;

const StudioNavigation: FC = () => (
  <Navigation
    variant="pink"
    renderAuthBlock={() => (
      <AuthUserMenuBlock
        size="medium"
        variant="pink"
        renderUserMenuBlock={() => <StudioUserMenuBlock />}
      />
    )}
    renderAdditionalButtons={() => (
      <Button href={createNewUrl} size="medium" variant="red">
        Start Creating
      </Button>
    )}
  />
);

export default StudioNavigation;
